import {
  GetMerchantSettingsResponse_MerchantSettings,
  PlainMessage,
} from "projects/frontend-client";
import { ControllerProps } from "react-hook-form";

export const requiredFieldShouldHaveAsterisk = (
  validators?: ControllerProps["rules"],
  merchantSettings?: PlainMessage<GetMerchantSettingsResponse_MerchantSettings>
): string => {
  const reqAsterisk =
    merchantSettings?.brandExperience?.fields?.requiredFieldShouldHaveAsterisk
      ?.kind.value;
  if (
    validators?.required &&
    reqAsterisk === true // just in case some sets it to "false" this will prevent it being triggered
  ) {
    return "*";
  }

  return "";
};
